"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NounsDescriptor__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "baseURI",
                type: "string",
            },
        ],
        name: "BaseURIUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "enabled",
                type: "bool",
            },
        ],
        name: "DataURIToggled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "PartsLocked",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "accessories",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "accessoryCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_accessory",
                type: "bytes",
            },
        ],
        name: "addAccessory",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_background",
                type: "string",
            },
        ],
        name: "addBackground",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_body",
                type: "bytes",
            },
        ],
        name: "addBody",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "_paletteIndex",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "_color",
                type: "string",
            },
        ],
        name: "addColorToPalette",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_glasses",
                type: "bytes",
            },
        ],
        name: "addGlasses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_head",
                type: "bytes",
            },
        ],
        name: "addHead",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_accessories",
                type: "bytes[]",
            },
        ],
        name: "addManyAccessories",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string[]",
                name: "_backgrounds",
                type: "string[]",
            },
        ],
        name: "addManyBackgrounds",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_bodies",
                type: "bytes[]",
            },
        ],
        name: "addManyBodies",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "paletteIndex",
                type: "uint8",
            },
            {
                internalType: "string[]",
                name: "newColors",
                type: "string[]",
            },
        ],
        name: "addManyColorsToPalette",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_glasses",
                type: "bytes[]",
            },
        ],
        name: "addManyGlasses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_heads",
                type: "bytes[]",
            },
        ],
        name: "addManyHeads",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "arePartsLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "backgroundCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "backgrounds",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "baseURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "bodies",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bodyCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "accessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                ],
                internalType: "struct INounsSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "dataURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "accessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                ],
                internalType: "struct INounsSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "generateSVGImage",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "accessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                ],
                internalType: "struct INounsSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "genericDataURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "glasses",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "glassesCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "headCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "heads",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isDataURIEnabled",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lockParts",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "palettes",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_baseURI",
                type: "string",
            },
        ],
        name: "setBaseURI",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "toggleDataURIEnabled",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "accessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                ],
                internalType: "struct INounsSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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__$e1d8844a0810dc0e87a665b1f2b5fa7c69$__6366b8c2418260026040518363ffffffff1660e01b815260040161096592919061212b565b600060405180830381865af4158015610982573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526109aa9190810190612192565b9392505050565b6000546060907501000000000000000000000000000000000000000000900460ff16156109e9576109e28383610bc2565b9050610a17565b60016109f48461181d565b604051602001610a05929190612200565b60405160208183030381529060405290505b92915050565b600481815481106105e257600080fd5b610a356113c3565b6001610a428284836122f5565b507f6741b2fc379fad678116fe3d4d4b9a1a184ab53ba36b86ad0fa66340b1ab41ad8282604051610a749291906123f2565b60405180910390a15050565b60026020528160005260406000208181548110610a9c57600080fd5b906000526020600020016000915091505080546105fd9061207e565b600681815481106105e257600080fd5b610ad06113c3565b60005474010000000000000000000000000000000000000000900460ff1615610b3b5760405162461bcd60e51b815260206004820152601060248201527f506172747320617265206c6f636b6564000000000000000000000000000000006044820152606401610585565b6106fb82826118db565b610b4d6113c3565b60005474010000000000000000000000000000000000000000900460ff1615610bb85760405162461bcd60e51b815260206004820152601060248201527f506172747320617265206c6f636b6564000000000000000000000000000000006044820152606401610585565b6106fb8282611918565b60606000610bcf8461181d565b9050600081604051602001610be49190612421565b6040516020818303038152906040529050600082604051602001610c089190612466565b6040516020818303038152906040529050610c24828287610df5565b9695505050505050565b600180546105fd9061207e565b610c436113c3565b610c4d6000611955565b565b610c576113c3565b60005474010000000000000000000000000000000000000000900460ff1615610cc25760405162461bcd60e51b815260206004820152601060248201527f506172747320617265206c6f636b6564000000000000000000000000000000006044820152606401610585565b60005b818110156105cd57610cf9838383818110610ce257610ce2611fea565b9050602002810190610cf49190612019565b6119ca565b600101610cc5565b600581815481106105e257600080fd5b610d196113c3565b60ff831660009081526002602052604090205461010090610d3b9083906124f8565b1115610daf5760405162461bcd60e51b815260206004820152602160248201527f50616c65747465732063616e206f6e6c7920686f6c642032353620636f6c6f7260448201527f73000000000000000000000000000000000000000000000000000000000000006064820152608401610585565b60005b81811015610def57610de784848484818110610dd057610dd0611fea565b9050602002810190610de29190612019565b611a07565b600101610db2565b50505050565b606060006040518060800160405280868152602001858152602001610e19856114a4565b81526020016003856000015165ffffffffffff1681548110610e3d57610e3d611fea565b906000526020600020018054610e529061207e565b80601f0160208091040260200160405190810160405280929190818152602001828054610e7e9061207e565b8015610ecb5780601f10610ea057610100808354040283529160200191610ecb565b820191906000526020600020905b815481529060010190602001808311610eae57829003601f168201915b5050505050815250905073__$e1d8844a0810dc0e87a665b1f2b5fa7c69$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";
const isSuperArgs = (xs) => {
    return (typeof xs[0] === "string" ||
        Array.isArray(xs[0]) ||
        "_isInterface" in xs[0]);
};
class NounsDescriptor__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            const [linkLibraryAddresses, signer] = args;
            super(_abi, NounsDescriptor__factory.linkBytecode(linkLibraryAddresses), signer);
        }
    }
    static linkBytecode(linkLibraryAddresses) {
        let linkedBytecode = _bytecode;
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$e1d8844a0810dc0e87a665b1f2b5fa7c69\\$__", "g"), linkLibraryAddresses["contracts/libs/NFTDescriptor.sol:NFTDescriptor"]
            .replace(/^0x/, "")
            .toLowerCase());
        return linkedBytecode;
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NounsDescriptor__factory = NounsDescriptor__factory;
NounsDescriptor__factory.bytecode = _bytecode;
NounsDescriptor__factory.abi = _abi;
